module.exports = __webpack_public_path__ + "favicon-32x32.6a2b86ad.png";


//////////////////
// WEBPACK FOOTER
// ./client/containers/App/favicon-32x32.png
// module id = 640
// module chunks = 0